module.exports = __webpack_public_path__ + "img/20201013_151043.34fb9ebc.jpg";